import React, { useEffect, useMemo, useState } from "react";

export default function SearchOrder({ onSearched = () => { }, recentOrders = [] }) {
    const [orderId, setOrderId] = useState("");
    const [assignedOrder, setAssignedOrder] = useState("");   // ⬅️ Assigned Order (top-right)
    const [now, setNow] = useState(() => new Date());

    // live date-time
    useEffect(() => {
        const t = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(t);
    }, []);

    const statuses = useMemo(
        () => ([
            { label: "Camera Status", ok: false, okText: "Camera Name", iconOk: "bi-check-circle-fill", iconBad: "bi-x-circle-fill" },
            { label: "Printer Status", ok: false, okText: "Printer Name", iconOk: "bi-check-circle-fill", iconBad: "bi-x-circle-fill" },
            { label: "Scanner Status", ok: false, okText: "Scanner Name", iconOk: "bi-check-circle-fill", iconBad: "bi-x-circle-fill" },
        ]),
        []
    );

    const handleSearch = () => {
        const trimmed = orderId.trim();
        if (!trimmed) return;
        setAssignedOrder(trimmed);   // ⬅️ put searched order into Assigned
        onSearched(trimmed);
    };

    const handleReset = () => setOrderId("");
    const fillFromHistory = (id) => setOrderId(id);

    return (
        <div className="row gx-3">
            {/* LEFT */}
            <div className="col-lg-8">
                <div className="border rounded-3 p-4 h-100 bg-light">
                    <h5 className="mb-3 text-center">Order Number</h5>

                    {/* input centered, width controlled by grid not inline */}
                    <div className="row justify-content-center mb-3">
                        <div className="col-12 col-md-8">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter/Scan Order Number"
                                value={orderId}
                                onChange={(e) => setOrderId(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-center gap-2 mb-4">
                        <button type="button" className="btn btn-primary" onClick={handleSearch}>
                            <i className="bi bi-search me-1" /> Search
                        </button>
                        <button type="button" className="btn btn-outline-secondary" onClick={handleReset}>
                            Reset
                        </button>
                    </div>

                    <div className="mt-3 mx-auto" style={{ maxWidth: 640 }}>
                        {statuses.map((s, idx) => (
                            <div
                                key={idx}
                                className="d-flex align-items-center justify-content-between border rounded-2 px-3 py-2 mb-2 bg-white"
                            >
                                <div className="fw-semibold">{s.label}</div>
                                <div className="d-flex align-items-center">
                                    {s.ok ? (
                                        <>
                                            <span className="me-2 small text-muted">{s.okText}</span>
                                            <i className={`bi ${s.iconOk} text-success fs-5`} />
                                        </>
                                    ) : (
                                        <i className={`bi ${s.iconBad} text-danger fs-5`} />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* RIGHT (stacked: Assigned Order on top, Recent Orders below with smaller height) */}
            <div className="col-lg-4">
                <div className="d-flex flex-column gap-3 h-100">

                    {/* Assigned Order (top) */}
                    <div className="border rounded-3 p-3">
                        <h6 className="mb-2">Assigned Order</h6>
                        <div className="small text-muted">
                            {now.toLocaleDateString()} {now.toLocaleTimeString()}
                        </div>
                        <div className="mt-2">
                            {assignedOrder
                                ? <span className="fw-semibold">{assignedOrder}</span>
                                : <span className="text-muted">—</span>}
                        </div>
                    </div>

                    {/* Recent Orders (bottom, compact + scroll) */}
                    <div className="border rounded-3 p-3 flex-grow-1">
                        <h6 className="mb-3 text-center">Recent Orders</h6>

                        {recentOrders.length === 0 ? (
                            <div className="text-muted small text-center">No recent searches</div>
                        ) : (
                            <div className="overflow-auto" style={{ maxHeight: 240 }}>
                                <ul className="list-group">
                                    {recentOrders.map((id) => (
                                        <li
                                            key={id}
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                            role="button"
                                            onClick={() => fillFromHistory(id)}
                                        >
                                            <span className="text-truncate">{id}</span>
                                            <div className="d-flex align-items-center text-muted small">
                                                <i className="bi bi-clock me-1" /> 
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}
